module.exports = __webpack_public_path__ + "static/img/AR.7c0b270f.png";